import { Outlet } from 'react-router-dom'

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex">
      {/* Left Side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12">
        <div className="max-w-md text-center">
          {/* Logo */}
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-500 rounded-2xl mb-4">
              <span className="text-4xl">💬</span>
            </div>
            <h1 className="text-4xl font-bold text-white mb-2">ReplyForge</h1>
            <p className="text-xl text-yellow-500">Customer Support Platform</p>
          </div>
          
          {/* Features */}
          <div className="space-y-4 text-left">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <span className="text-yellow-500">✓</span>
              </div>
              <div>
                <h3 className="text-white font-medium">AI-Powered Support</h3>
                <p className="text-gray-400 text-sm">Automate 80% of customer inquiries</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <span className="text-yellow-500">✓</span>
              </div>
              <div>
                <h3 className="text-white font-medium">Multi-Channel</h3>
                <p className="text-gray-400 text-sm">Chat widget, email, and more</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-yellow-500/20 rounded-lg flex items-center justify-center">
                <span className="text-yellow-500">✓</span>
              </div>
              <div>
                <h3 className="text-white font-medium">Shopify Integration</h3>
                <p className="text-gray-400 text-sm">Real-time order lookups</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Right Side - Auth Forms */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
